import { AuditStatus, ThemePalette } from 'shared/enums';

export class AuditHelper {
	public static AuditStatusColor(status: AuditStatus | 'onsite'): ThemePalette {
		switch (status) {
			case AuditStatus.AUDITED:
				return ThemePalette.SUCCESS;
			case AuditStatus.UNAUDITED:
				return ThemePalette.SECONDARY;
			case 'onsite':
				return ThemePalette.PRIMARY;
			case AuditStatus.UNAVAILABLE:
			default:
				return ThemePalette.NEUTRAL;
		}
	}
}
